const flattenRoutes = (array) => array.reduce((res, { sub = [], ...rest }) => res.concat(rest).concat(flattenRoutes(sub)), []);

export default flattenRoutes;
